import { render, staticRenderFns } from "./WorkshopControlListTable.vue?vue&type=template&id=2809752d&"
import script from "./WorkshopControlListTable.vue?vue&type=script&lang=js&"
export * from "./WorkshopControlListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports